import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as BratoiActions from './bratoi.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';
// import { Channels } from 'src/app/Store/channels';

@Injectable({
  providedIn: 'root'
})
export class BratoiStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new BratoiActions.BratoiRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.BRATOI, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new BratoiActions.BratoiCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new BratoiActions.BratoiUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new BratoiActions.BratoiDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new BratoiActions.BratoiRefresh());
      }
    });

  }
}
